import { render, staticRenderFns } from "./DescriptionIcon.vue?vue&type=template&id=f8aea1b0&scoped=true&"
import script from "./DescriptionIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DescriptionIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8aea1b0",
  null
  
)

export default component.exports